import { useEffect, useState } from 'react';
import { saveItemToWP, getPostWP } from '../../actions/api';

function useSaveGuestOrGetItem(id, data, type) {
    const [ items, setItems ] = useState({
        rankedPlayers: [],
        selectedPlayers: [],
        selectedTeams: [],
        year: '',
        totalRounds: null
    });
    const [ loading, setLoading ] = useState(false);
    const [ isError, setError ] = useState(false);

    useEffect(() => {
        const saveItemToWPAsGuest = async () => {
            setError(false);
            setLoading(true);
            try {
                const json = await saveItemToWP(data, type, `Guest ${type}`, null);
                setItems({...data, wpID: json.id});
                setLoading(false);
            }
            catch (error) {
               setError(error);
                setLoading(false);
            }
        }
        const getItemFromWP = async () => {
            setError(false);
            setLoading(true);
            try {
                const json = await getPostWP(id, type);
                const parsed = JSON.parse(json.data);
                setItems({...parsed, title: json.title.rendered});
                setLoading(false);
            }
            catch (error) {
               setError(error);
                setLoading(false);
            }
        }
        id ? getItemFromWP() : saveItemToWPAsGuest();
    },[]); // data, id, type, setItems
    return [items, loading, isError];
}

export default useSaveGuestOrGetItem;